export enum KeyboardModifier {
  None,
  Shift,
  Alt,
  ShiftAlt,
}
